var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "speed-dial-demo" }, [
    _c(
      "div",
      [
        _c("h4", [_vm._v(" 默认 ")]),
        _c(
          "fu-speed-dial",
          [
            _c("fu-speed-dial-item", {
              attrs: { index: 0, title: "No.0" },
              on: { click: _vm.clickItem }
            }),
            _c("fu-speed-dial-item", {
              attrs: { index: 1, title: "No.1" },
              on: { click: _vm.clickItem }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      [
        _c("h4", [_vm._v(" Items数组 ")]),
        _c("fu-speed-dial", { attrs: { items: _vm.items } })
      ],
      1
    ),
    _c(
      "div",
      [
        _c("h4", [_vm._v(" Slot ")]),
        _c(
          "fu-speed-dial",
          [
            _c("fu-speed-dial-item", {
              attrs: {
                index: 0,
                title: "No.0",
                color: "#222",
                "bg-color": "#DDD",
                "title-bg-color": "#F1F1F1",
                "title-color": "#555"
              },
              on: { click: _vm.clickItem }
            }),
            _c("fu-speed-dial-item", {
              attrs: {
                index: 1,
                title: "No.1",
                "button-class": "custom-button",
                "title-class": "custom-title"
              },
              on: { click: _vm.clickItem }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      [
        _c("h4", [_vm._v(" Item Slot ")]),
        _c(
          "fu-speed-dial",
          { ref: "speed-dial" },
          [
            _c(
              "fu-speed-dial-item",
              { attrs: { index: 0 } },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.clickItem(
                          { title: "Item 1", index: 0, custom: true },
                          $event
                        )
                      }
                    }
                  },
                  [_vm._v("Item 1")]
                )
              ],
              1
            ),
            _c(
              "fu-speed-dial-item",
              { attrs: { index: 1 } },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.clickItem({
                          title: "Item 2",
                          index: 1,
                          custom: true
                        })
                      }
                    }
                  },
                  [_vm._v("Item 2")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }